import styled from 'styled-components';

export const ActivecardLayoutDiv = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    width:100%;
    background-color:${props.theme.colors.white.base};
    border-radius:${props.theme.misc.borderRadius.custom(4)};
    margin-top: 0.8rem;
    
  `,
);

export const ActivepcardInnerLayoutDiv = styled.div(
  props => `
  
    display:flex;
    flex-wrap: wrap;
    width:100%;
    background-color:${props.theme.colors.white.base};
    border-radius:${props.theme.misc.borderRadius.custom(4)};
    padding: 2.5rem 2rem;
  
  
  `,
);
export const AmminitiesLayoutDiv = styled.div(
  props => `
  
      display:flex;
      flex-wrap: wrap;
      width:100%;
      background-color:${props.theme.colors.white.base};
      border-bottom-left-radius:${props.theme.misc.borderRadius.custom(4)};
      border-bottom-right-radius:${props.theme.misc.borderRadius.custom(4)};
      border-top: 1px solid #eff3f8;
      padding: 1rem 2rem;
      align-items: center;
      justify-content: space-between;
  
    `,
);

export const AmminitiesInnerLayoutDiv = styled.div(
  props => `
  
      display:flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    `,
);

export const LoaderWrap = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
`;
export const ImageWrapDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 43%;
`;
export const TextWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 23%;
`;
export const ImageWrap = styled.div`
  margin-right: 2rem;
`;

export const ButtonWrap = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  width: 33%;
`;
